import * as React from 'react';
import { setFeatureFlag, FeatureName } from 'owa-feature-flags';
import { observer } from 'mobx-react';
import { Toggle } from 'office-ui-fabric-react/lib/components/Toggle';
import { Link } from 'office-ui-fabric-react/lib/Link';

const styles = require('./FeatureFlagsListItem.scss');
export interface Props {
    name: string;
    isOn: boolean;
}

@observer
export default class FeatureFlagsListItem extends React.Component<Props, {}> {
    render() {
        const { name, isOn } = this.props;
        return (
            <div className={styles.container}>
                <Toggle
                    checked={isOn}
                    onText={''}
                    offText={''}
                    className={styles.toggle}
                    onChanged={value => setFeatureFlag(name as FeatureName, !isOn)}
                    title={name}
                />
                <Link
                    href={`https://osp.office.net/SubstrateFlex/Flex/flight/OutlookWeb/${name}`}
                    target="_blank">
                    {name}
                </Link>
            </div>
        );
    }
}
